import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=241a8d69&scoped=true"
import script from "@/views/Settings/Brands/Brands.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Brands/Brands.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Brands/brands.scss?vue&type=style&index=0&id=241a8d69&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a8d69",
  null
  
)

export default component.exports